import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Commonalert = ({title, message, redirectTo, onClose}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    const elems = document.getElementsByClassName("common_alert_popup");
    for (let i = 0; i < elems.length; i += 1) {
      elems[i].style.display = "block";
    }
  }, []);

  const popupClose = () => {
    const elems = document.getElementsByClassName("common_alert_popup");
    for (let i = 0; i < elems.length; i += 1) {
      elems[i].style.display = "none";
    }
    if (redirectTo) {
      if (
        typeof redirectTo === "object" &&
        redirectTo.path
      ) {
        navigate(redirectTo.path, {
          state: redirectTo.state,
        });
      } else {
        navigate(redirectTo);
      }
      return;
    }
    const loc = window.location.pathname;
    if (
      loc === "/social-links" ||
      loc === "/changepassword" ||
      loc === "/products" ||
      loc === "/account"
    ) {
      window.location.reload();
      return;
    }
    if (loc === "/holiday/add/") {
      window.location.href = "/holiday";
      return;
    }
    if (loc === "/freeproducts/addfreeproducts") {
      window.location.href = "/freeproducts";
      return;
    }
    if (
      loc === `/freeproducts/editfreeproducts/${loc.split("/").at(-1)}`
    ) {
      window.location.href = "/freeproducts";
      return;
    }
    if (
      loc === "/ingredients/add/" ||
      loc === `/ingredients/edit/${loc.split("/").at(-1)}`
    ) {
      window.location.href = "/ingredients";
      return;
    }
    if (
      loc === "/allergens/add/" ||
      loc === `/allergens/edit/${loc.split("/").at(-1)}`
    ) {
      window.location.href = "/allergens";
      return;
    }
    if (
      loc === `/master-entry/${loc.split("/").at(-1)}` ||
      loc === `/master-entry/add/${loc.split("/").at(-1)}`
    ) {
      window.location.href = `/master-entry/${loc.split("/").at(-1)}`;
      return;
    }
    if (
      loc ===
      `/master-entry/edit/${loc.split("/").at(-2)}/${loc.split("/").at(-1)}`
    ) {
      window.location.href = `/master-entry/${loc.split("/").at(-2)}`;
      return;
    }
    if (
      loc === "/role/addRoles/" ||
      loc === `/role/editRoles/${loc.split("/").at(-1)}`
    ) {
      window.location.href = "/role";
      return;
    }
    if (
      loc === "/account/adduser"
    ) {
      window.location.href = "/account";
      return;
    }
    if (
      loc ===
      `/resetpassword/${loc.split("/").at(-2)}/${loc.split("/").at(-1)}`
    ) {
      window.location.href = "/";
      return;
    }
    if (
      loc === "/freesample/freecode/add/" ||
      loc === `/freesample/freecode/edit/${loc.split("/").at(-1)}`
    ) {
      window.location.href = "/freesample/freecode";
      return;
    }
    if (
      loc === "/email-configuration" ||
      loc === "/email-configuration/add" ||
      loc === "/email-configuration/edit"
    ) {
      window.location.href = "/email-configuration";
      return;
    }
    if (loc === "/email-campaign") {
      window.location.href = "/email-campaign";
    }
  };

  return (
    <div
      className="custom-alert-pop common_alert_popup"
      style={{ display: "block" }}
    >
      <div className="custom-alert-container">
        <div className="custom-alert-wrap">
          <div className="custom-alert-header">
            <h4>{title}</h4>
          </div>
          <div className="custom-alert-body">
            <p>{message}</p>
            <div className="alert-buttons">
              <a
                title={t("ok_txt")}
                onClick={() => {
                  popupClose();
                  if (onClose) {
                    onClose();
                  }
                }}
                className="popup-alert-btn button"
              >
                {t("ok_txt")}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Commonalert;